<template>
    <SimpleAlert @cancel="$emit('cancel')" @approve="triggerReboot" :open="open" :title="$t('device.action.reboot')" :description="$t('alert.rebootDeviceDescription')" :action="$t('device.action.reboot')" type="warning" />
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import SimpleAlert from "@/components/modals/SimpleAlert";
import i18n from "@/i18n";

export default {
    components: {
        SimpleAlert,
    },
    props: ["open"],
    emits: ["cancel"],
    setup(props, { emit }) {
        const store = useStore();

        const device = computed(() => store.state.device.current);

        const triggerReboot = async () => {
            const serialNumber = device.value.serialNumber;


            const success = await store.dispatch("device/triggerSprinterJob", {
                things: [device.value.id],
            });

            if (success) {
                store.commit("showNotification", {
                    title: i18n.global.t("notifications.mutations.rebootSuccess"),
                    text: i18n.global.t("notifications.mutations.deviceRebootTriggered", { serialNumber }),
                    type: "info",
                });
            } else {
                store.commit("showNotification", {
                    title: i18n.global.t("notifications.mutations.error"),
                    text: i18n.global.t("notifications.mutations.deviceRebootFailed", { serialNumber }),
                    type: "error",
                });
            }

            emit("cancel");
        };

        return {
            triggerReboot,
        };
    },
};
</script>
